export default __webpack_public_path__ + "static/cashflow_new_16-211cfc661ec6576da70d64a0bd64f551.jpg";